import { useState, useEffect, useRef } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { Link } from "react-router-dom";
import { createPortal } from "react-dom";

export default function ExpandableText({
  text,
  isLoadingData,
  isPlaceholder,
  type,
  to,
  query,
  className,
}) {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const iconRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const containerRef = useRef(null);
  const tooltipRef = useRef(null);

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  const highlightMatch = (text, query) => {
    if (!query) return text;

    const escapedQuery = escapeRegExp(query);
    const regex = new RegExp(`(${escapedQuery})`, "gi");

    return text.split(regex).map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expanded &&
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  useEffect(() => {
    if (expanded && containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.bottom + window.scrollY + 12, // možeš smanjiti ili povećati razmak po potrebi
        left: rect.left + window.scrollX,
      });
    }
  }, [expanded]);

  useEffect(() => {
    const checkTruncation = () => {
      const el = textRef.current;
      if (el) {
        setIsTruncated(
          el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight,
        );
      }
    };

    checkTruncation();
    window.addEventListener("resize", checkTruncation);

    return () => {
      window.removeEventListener("resize", checkTruncation);
    };
  }, [text]);

  return (
    <div className={`flex-direction-row relative width-100 expendable-text`}>
      <div
        className={`flex-direction-row gap-4 relative width-100 ${className}`}
        ref={containerRef}
      >
        {type === "link" ? (
          <Link
            ref={textRef}
            to={`../${to}`}
            className={`inria-sans-400 font-14 text`}
          >
            {!isLoadingData && highlightMatch(text, query)}
          </Link>
        ) : (
          <p
            ref={textRef}
            className={`inria-sans-400 font-14 text   ${
              isPlaceholder && "animated-bg-text animated-bg"
            } ${isPlaceholder ? "a" : ""} ${
              type === "status" ? className : ""
            }`}
          >
            {!isLoadingData && highlightMatch(text, query)}
          </p>
        )}

        {isTruncated && (
          <img
            ref={iconRef}
            className="pointer"
            src={icons.info}
            width={12}
            height={12}
            onClick={() => setExpanded(!expanded)}
            alt="info"
          />
        )}
      </div>
      {expanded &&
        createPortal(
          <div
            ref={tooltipRef}
            className="tooltip inria-sans-400 font-14"
            style={{
              position: "absolute",
              top: tooltipPos.top,
              left: tooltipPos.left,
              zIndex: 9999,
            }}
          >
            {!isLoadingData && text}
          </div>,
          document.body,
        )}
    </div>
  );
}
